// const lost_animals = {
//   "Group Description": [
//     "Dedicated to helping find lost animals and providing support to those who have lost a pet.",
//     "Focus on reuniting lost pets with their owners.",
//   ],
//   "Posting Rules": [
//     "Include pet's name, description, identification marks, date, location, and contact information.",
//     "Add photos or videos and optional reward information.",
//     "Provide updates if the pet is found or not.",
//   ],
//   "Resources for Finding Lost Pets": [
//     "Act quickly within the first 48 hours.",
//     "Thoroughly search the last-seen area, talk to people, and put up posters.",
//     "Check with shelters, feeders, and vets.",
//     "File a complaint and FIR at the police station.",
//     "Look for CCTV footage and respond to every lead.",
//     "Leave the pet's favorite things outside.",
//   ],
//   "Tips to Prevent Losing a Pet": [
//     "Microchip your pet and keep contact information up-to-date.",
//     "Use a collar and ID tag with your information.",
//     "Consider a GPS tracker for your pet's collar.",
//     "Train your pet to come when called and stay close.",
//     "Keep your pet secure when you're not home and check for escape routes.",
//   ],
//   "Animal Welfare Organizations in Bangalore": [
//     "People For Animals (PFA Bangalore) :Contact at +91 99000 25370 or visit www.peopleforanimalsbangalore.org.",
//     "CUPA (Compassion Unlimited Plus Action): Contact at 080-22947317 or visit www.cupabangalore.org.",
//     "Sarvodaya Sevabhavi Samstha: Contact at 080-23520407 or visit www.sarvodayaindia.org.",
//     "Let's Live Together: Contact at 080-23650006 or visit www.letslivetogether.org.",
//   ],
// };

// const stray_animals = {
//   "Group Description": [
//     "Focuses on raising awareness and providing support for stray animals.",
//     "Provides a space for animal lovers to connect, share experiences, and offer assistance.",
//     "Allows sharing of lighthearted content and information about stray animals.",
//   ],
//   "Safety from Stray Animals": [
//     "Avoid running away from stray dogs.",
//     "Do not confront a pack of dogs, especially at night.",
//     "Avoid aggression signals and use calming signals.",
//     "Seek help from locals if feeling threatened.",
//     "As a last resort, crouch down and pretend to pick up a rock.",
//   ],
//   "Approaching Stray Dogs": [
//     "Evaluate behavior and watch for signs of aggression or illness.",
//     "Approach calmly and avoid cornering the dog.",
//     "Let the dog approach and speak in a calm voice.",
//     "Offer your hand for them to smell and gradually build trust.",
//   ],
//   "Feeding to Build Trust": [
//     "Bring food regularly to the dog's hangout spot.",
//     "Gradually move closer while they eat.",
//     "Offer food from your hand and reward with treats.",
//   ],
// };

// const general_animals = {
//   "Group Description": [
//     "Welcoming space for members to ask questions, seek advice, and share general animal content.",
//     "Focuses on connecting animal lovers and expanding knowledge and appreciation for animals.",
//   ],
// };

// const animal_emergency = {
//   "Group Description": [
//     "Dedicated to providing critical and immediate attention to animals in urgent need of care.",
//     "Encourages sharing of experiences and knowledge about emergency animal care.",
//   ],

//   "Dealing with an Animal Emergency": [
//     "Stay calm and assess the situation.",
//     "Contact animal rescue services for help.",
//     "Provide temporary care if possible.",
//     "Follow up with updates on the animal's condition.",
//     "Act quickly and responsibly in emergencies.",
//   ],
//   "How to Help in an Animal Emergency": [
//     "Contain the animal in a safe area.",
//     "Provide shelter, food, water, and warmth.",
//     "Monitor the animal's condition and behavior.",
//     "Contact local animal welfare organizations for assistance.",
//   ],
// };

// const animal_adoption = {
//   "Group Description": [
//     "Connects potential adopters with animals in need of a loving home.",
//     "Focuses on promoting animal adoptions and sharing adoption experiences and tips.",
//   ],
//   "Posting Rules": [
//     "Only post about animals available for adoption or animals you are looking to adopt.",
//     "Provide detailed information about the animal's breed, age, temperament, and any special needs or requirements.",
//     "Mention if the animal is neutered or not to prevent breeders from taking advantage.",
//     "Avoid making financial requests or soliciting donations related to adoptions.",
//   ],
//   "Considerations before Adoption": [
//     "Ensure you have the time and energy to train and care for a pet.",
//     "Consider adopting adult or senior animals in addition to puppies and kittens.",
//     "Discuss the decision to adopt with everyone in your family.",
//     "Assess your home's space and suitability for the pet's size and exercise needs.",
//     "Prepare for lifestyle changes and commit to meeting the pet's needs.",
//     "Budget for special food and vaccinations.",
//     "Plan for training, grooming, and providing appropriate accessories, toys, and treats.",
//     "Create a safe environment for your pet at home.",
//   ],
//   "Animal Adoption Resources in Bangalore": [
//     "Charlie's Animal Rescue Centre, Yelahanka: Contact at +91 99704 04025.",
//     "Bangalore Cat Squad: Contact at +91 98455 53850.",
//     "Precious Paws Foundation: Contact at +91 97425 43510.",
//     "Let's Live Together, Rajaji Nagar: Contact at +91 99864 13916.",
//     "CUPA Second Chance, Dommasandra: Contact at +91 81972 53047.",
//     "Dogspot.In: Visit their website at www.dogspot.in.",
//     "Cat Studio At CARE, Yelahanka: Contact at +91 94839 11110.",
//     "Krupa, Kengeri: Contact at +91 98805 63690.",
//   ],
// };

export const intro_para =
  "Here are resources specifically for helping stray animals in need. Please use them only for this purpose. These resources are currently available for Bangalore, but we will update them for other cities soon. Additionally, we will soon provide resources for your personal pets.";

export const all_resources = [
  {
    topic: "Cat Neutering",
    content: [
      "Neutering animals is important to control the population of stray cats and dogs as there are not enough resources to care for all of them. Animal Birth Control programs involve sterilization which is a common surgery and includes vaccinating against rabies. Neutering can reduce unwanted behaviors such as aggression and territorial fights. Both male and female animals can be neutered but priority is given to females, and the animal must be at least 6 months old, not feeding offspring, and not pregnant. It's essential to treat any visible health issues before neutering. Vaccinating the animal 15 days before neutering is recommended. Initiating and curating animal birth control programs for community animals is necessary as the government is not capable of conducting these programs for all stray animals.",
      "Where to neuter a cat?",
      "There are no services for cats that provide neutering on a regular basis for free. So one has to use private establishments and clinics that neuter / sterilize and vaccinate cats at a subsidized cost. Please call the clinic before you plan the neutering operation in order to confirm the final cost and the availability of surgeons/boarding facility,etc.",
    ],
    contact_list: [
      {
        name: "PFA",
        address: "Sunkalpalya, Bengaluru, Karnataka 560060",
        contact: "General Manager 9741783232 | Dr. Darsh 8884846668",
        cost: "2,000 INR per cat",
        boarding: "Not available",
        note: "",
      },
      {
        name: "HOPE",
        address: "3PW5+5C8, Marsandra, Bengaluru, Karnataka 562129",
        contact: "Dr Akshay +919590608385",
        cost: "2,500 INR per cat",
        boaring: "3-4 days is included in the cost",
        note: "",
      },
      {
        name: "CARTMAN ANIMAL HOSPITAL",
        address:
          "CA-18, 17D Main, 6th Block, Koramangala, behind Koramangala Club, Bengaluru, Karnataka 560095",
        contact: "+919108805001",
        cost: "2,500 INR per cat",
        boaring: "3-4 days is included in the cost",
        note: "",
      },
      {
        name: "CUPA (ULSOOR)",
        address: "Ulsoor",
        contact: "+919972244078",
        cost: "",
        boarding:
          "SOMETIMES CUPA ULSOOR CONDUCTS FREE STERILIZATIONS FOR CATS - DO ENQUIRE FOR THE SAME",
        boaring: "",
      },
    ],
    link: "",
  },
  {
    topic: "Dog Neutering",
    content: [
      "FREE NEUTERING WITH BBMP",
      "Below is the table that will help you understand whether or not your area is covered by BBMP. If in doubt — call a few numbers to confirm. One can also ask fellow volunteers in the numerous WhatsApp/Facebook groups listed in the end of this document.",
      "If your area is covered - strat with calling the BBMP team to come over to your location and catch the dogs. Once caught, the BBMP team will take the dogs to the neutering center, neuter them, vaccinate them against rabies, and bring the dogs back to your location in 3-5 days.",
      "Important things to keep in mind:",
      "Please try to be present during pick-ups and drops. Take the driver's phone number and inform the team of your intentions to be present.",
      "During each drop ensure the following:",
      "That the right dogs are being released at the right location. Taking pictures at the time of pick ups and referring to them at the time of drops has proven helpful.",
      "That every dog released has been neutered. This can be checked by asking the team, seeing a clipped ear, and a post-surgery stitch.",
      "Sometimes, BBMP does not neuter certain dogs due to age/weight/health issues and just releases them back to their location.",
      "If this happens, it is advisable to not release the dog, as it would be hard to catch it again later. Instead, ask the team to help you get a hold of the dog by closing it in a room / taking on a leash, and then drive it to one of the private clinics for subsidized neutering.",
      "If one can not drive, services of hired transportation people can be used. The amount spent can later be fundraised in WhatsApp / Facebook groups.",
      "That every dog released has been vaccinated against rabies. This can be checked by asking the team and seeing a big paint mark on the dog's body.",
      "That  of the dogs released had any post-surgery complications or any non-surgery related health issues while at the BBMP center. This can be checked by asking the team.",
      "That at the time of release the team tries to catch more dogs in your area.",
      "If you are lucky — the BBMP team will come over a few times and catch all the dogs that need to be neutered at your locality. However, it sometimes happens that the BBMP team is unable to catch all the dogs, or is unable to keep coming to your locality over and over again.",
      "In those cases, please don't give up. Use the help of hired professionals listed below to catch the remaining dogs and then transport them to the BBMP facility for neutering.",
      "That way, one will only have to pay for catching and transport, while the neutering and vaccination will still be free. Funds spent won’t be much and can be later fundraised for within the community or through the WhatsApp/Facebook groups listed in the end of this document.",
      "SUBSIDIZED NEUTERING AT PRIVATE CLINICS",
      "If one’s locality is not covered by BBMP, or if BBMP refuses to neuter certain dogs because of age/weight/health conditions — one has to use private establishments and clinics that neuter/sterilize and vaccinate dogs at a subsidized cost.",
      "Below is the list of such clinics",
      "Please call the clinic before you plan the neutering operation in order to confirm the final cost ad the availability of surgeons/boarding facility, etc.",
    ],
    contact_list: [
      {
        name: "PFA",
        address: "Sunkalpalya, Bengaluru, Karnataka 560060",
        contact: "General Manager 9741783232 | Dr. Darsh 8884846668",
        cost: "2,000 INR per dog",
        boaring: "3-4 days is included in the cost",
        note: "",
      },
      {
        name: "CUPA Spay & Neuter Center",
        address:
          "229/1, Muthanallur Cross Sarjapura Road, Landmark:, opposite to BB Jewellers, Dommasandra, Bengaluru, Karnataka 562125",
        contact: "+91 98805 24280",
        cost: "2,500 INR per dog",
        boaring: "3-4 days is included in the cost",
        note: "Pick-Up, Drop & Catching services: Available at no additional cost if there are at least 7-10 dogs to be caught at a time",
      },
      {
        name: "HOPE",
        address: "3PW5+5C8, Marsandra, Bengaluru, Karnataka 562129",
        contact: "Dr Akshay +919590608385",
        cost: "3,000 INR per dog",
        boaring: "3-4 days is included in the cost",
        note: "",
      },
      {
        name: "CARTMAN ANIMAL HOSPITAL",
        address:
          "CA-18, 17D Main, 6th Block, Koramangala, behind Koramangala Club, Bengaluru, Karnataka 560095",
        contact: "+919108805001",
        cost: "3,000 INR per dog",
        boaring: "3-4 days is included in the cost",
        note: "",
      },
    ],
    link: "",
  },
  {
    topic: "How to Secure a Cat",
    content: [
      "Here is some useful information and contact details regarding the proper handling, catching, and transportation of cats.",
      "If the cat lets you touch it — it’s easy to pick it up and put it in a box. Be careful however as cats in pain are likely to scratch, one can use a towel for protection.",
      "Even though an animal carrier is preferable, any box (even Amazon carton box) would do.",
      "Make sure there is an airflow circulation for the cat to breathe, but at the same time ensure that the box is secured, as cats are very fast and cunning escapers. Letting the cat escape in an unknown environment can be fatal despite the best intentions, so please be careful about securing the box the cat is in.",
      "If the cat doesn’t let you touch it — there are a few things you can do to get a hold of the cat:",
      "a) Hire a cat catcher",
      "Syed, whom I (Vladyslava) have worked with personally and can vouch for his expertise and reliability, +91 81055 36711",
      "Dinesh +91 97389 94033",
      "Kiran +918431885400",
      "Tips:",
      "Catchers can also help with transporting the animal",
      "Make sure to discuss all the costs included and terms of payment with the catcher for each particular case",
      "Some catchers charge extra for fuel, for nighttime, etc.",
      "Some catchers charge nothing if the catch fails, some charge just fuel if the catch fails, and some charge the full amount irrespective of whether or not the catch is successful.",
      "Make sure to let the catcher know all the details about the situation such as previous attempts at catching the cat, its temperament (friendly/scared/aggressive), its surrounding area, etc.",
      "b) Rent/Make a trap",
      "A professional trap is the easiest way to catch a non-friendly cat. It works such that you place the food inside a special cage (raw meat works best), and leave the cat alone. Cat then feels comfortable being alone (may take time for them to brave up, especially if they are not hungry), enters the trap to get the food, and the trap automatically closes.",
      "Such traps can be rented at:",
      "1. Let's Live Together at 500 a day (but they ask for a 5000 INR refundable security deposit): +91 99864 13916",
      "2. CUPA Admin Office: at 500 a week (but they ask for a 5000 INR refundable security deposit): +91 99722 44078",
      "3. I (Vladyslava, the initial author of this guide) have purchased such a trap myself from my own pocket too. I intend to give it out to people in need for free with a minimum refundable security deposit amount.",
      "I am reachable at +91 799 33 81 521.",
      ,
      "4. One of the volunteers also owns such a trap and can lend it to people. Please don’t call him, WhatsApp only: +91 99800 72775",
      "Tips:",
      "Usually, organizations that rent out traps require one to come in person to pick up and drop off the trap. However, in emergencies, one may try to request paying the deposit online, signing the documents online and send dunzo / swiggy genie / an empty auto through ola or uber to pick up and drop the trap. Such requests were accommodated in some cases to save time.",
      "The deposit is charged because such traps are quite costly, and some people are not very responsible and don’t give back the trap or don’t take care of it properly.",
      "However, in emergencies, one may request to leave one’s passport as a deposit instead of money or request people to volunteer and help pay this refundable deposit through various WhatsApp and Facebook groups.",
      "A similar trap can be made by using a standard cage (that can be borrowed from a volunteer or a pet parent in one of the WhatsApp/Facebook groups), tying a long rope to the door, leaving the food inside, and waiting from a distance for the cat to enter the cage. Once all 4 legs of the cat are firmly inside the cage, one has to pull the rope fast and close the door.",
      "If there is any vacant room nearby that the cat can potentially enter if one throws the chicken inside — the same mechanism can be done with a room instead of a cage by tying the rope to the room’s door. However, do not enter the room on your own. Cornered cats can get very aggressive. Seek help! Many transportation people whose contacts are provided below could help.",
      "There are also a few videos on YouTube that show how to hand-make different cat traps. I have personally never tried any so can’t vouch for their efficiency, but leaving the link here just in case someone finds it useful.",
      "IF NOTHING WORKS, PLEASE CALL THE BELOW NUMBERS AND INFORM THEM OF THE SITUATION IN DETAIL:",
    ],
    contact_list: [
      {
        name: "Government Helpline",
        address: "",
        contact: "+918277100200",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Alai Rescue",
        address: "",
        contact: "+919739288282",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Care Rescue",
        address: "",
        contact: "+919035999372",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Krupa Rescue",
        address: "",
        contact: "+919880563690",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Girish Rescue",
        address: "",
        contact: "+919632201065",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "CUPA Rescue",
        address: "",
        contact: "+919845425678",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Sarvotham Rescue",
        address: "",
        contact: "+918123571619",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Friend For Animal Trust",
        address: "",
        contact: "+918147620003",
        cost: "",
        boaring: "",
        note: "(for cases around Vasanthnagar, Fraser Town, R T Nagar, Ulsoor)",
      },
    ],
    link: "",
  },
  {
    topic: "How to Secure a Dog",
    content: [
      "Leash",
      "Ideal for cases where the dog is friendly and is comfortable eating food near you.",
      "Things to remember:",
      "Any leash or even a rope would do",
      "If you do not have a box/a room to put an animal in right after you secure it and you are going to use the transportation services listed below — it is better to simply follow the animal until the transport arrives, and only when the transport arrives proceed with securing it. The whole operation then would be less stressful, as the moment you secure the dog on a leash, the transportation person can help right then and there by putting the animal in a net.",
      "Once secured — don’t let the animal escape. It will learn a lesson and will not let you catch it the same way again. Stay alert even if the animal seemingly calms down and relaxes.",
      "Do not let the animal choke — once secured, put two fingers in between a leash and a neck.",
      "Don’t panic — their resistance won’t last forever. Push the dog’s face and body toward the ground, and in 3-5 minutes it will calm down.",
      "Trap in a room",
      "By throwing the chicken inside from a distance, and closing the door once the dog is inside.",
      "The door can be closed from a distance by tying a rope to it in advance.",
      "Once the dog is closed in the room — people providing transportation services (listed below) generally are capable of entering the room with a net and securing the dog.",
      "Hire a dog catcher",
      "Hiring a professional dog catcher is ideal for those cases when there is no room around to trap the dog in, and the dog is too aggressive or terrified to let people come close to them even when food is used.",
      "Tips:",
      "Catchers can also help with transporting the animal.",
      "Make sure to discuss all the costs included and terms of payment with the catcher for each particular case.",
      "Some catchers charge extra for fuel, for nighttime, etc.",
      "Some catchers charge nothing if the catch fails, some charge just fuel if the catch fails, and some charge the full amount irrespective of whether or not the catch is successful.",
      "Make sure to let the catcher know all the details about the situation such as previous attempts at catching the dog, its temperament (friendly/scared/aggressive), its surrounding area, etc.",
      "Below are the contacts of professional dog catchers:",
      "1. Syed, whom I (Vladyslava) have worked with personally and can vouch for his expertise and reliability, +91 81055 36711",
      "2. Kiran +91 70192 92003 or +91 88928 12010",
      "3. Dinesh +91 97389 94033",
      "4. +91 808 82 52 132 Deepak",
      "IF NOTHING WORKS, PLEASE CALL THE BELOW NUMBERS AND INFORM THEM OF THE SITUATION IN DETAIL (When reporting a case to the numbers below, make sure to include the exact location, video of the animal, and contact number of someone who can show the animal when rescuers arrive.):",
    ],
    contact_list: [
      {
        name: "Government Helpline",
        address: "",
        contact: "+918277100200",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Alai Rescue",
        address: "",
        contact: "+919739288282",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Care Rescue",
        address: "",
        contact: "+919035999372",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Krupa Rescue",
        address: "",
        contact: "+919880563690",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Girish Rescue",
        address: "",
        contact: "+919632201065",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "CUPA Rescue",
        address: "",
        contact: "+919845425678",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Sarvotham Rescue",
        address: "",
        contact: "+918123571619",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Friend For Animal Trust",
        address: "",
        contact: "+918147620003",
        cost: "",
        boaring: "",
        note: "(for cases around Vasanthnagar, Fraser Town, R T Nagar, Ulsoor)",
      },
    ],
    link: "",
  },
  {
    topic: "Large Animals",
    content: [
      "Here is a list of helpful contacts for assisting larger animals in need.",
      "Large animals are usually treated on the spot by the nearest governmental veterinarian. Click here to open a list of governmental veterinarians.",
      "https://drive.google.com/file/d/1Ai6X3ft6phMu4nrzw5DjunRfOnIKqpn0/view?usp=sharing",
      "Sometimes (based on availability), CUPA LARRC (Large Animal Rescue & Rehabilitation Center) can help too. Their number is 080 2294 7317. Their address is Mutharayana Nagar, Gnana Bharathi, Bengaluru, Karnataka 560056.",
      "One can try inquiring with WRRC and Indian Wildlife: 080 2294 7307, 99006 03939.",
      "Below are also contacts of individuals that can help with large animal rescue:",
    ],
    contact_list: [
      {
        name: "Mahendra Singh",
        address: "",
        contact: "+919886869017",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Akhila Karnataka",
        address: "",
        contact: "+919902476719, +9108025532204",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Upendra Singh",
        address: "",
        contact: "+919845366029",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Sanjay",
        address: "",
        contact: "+919945429780",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Pushpa",
        address: "",
        contact: "+917673935549",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Upendra",
        address: "",
        contact: "+919845366029",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "WSA Founder Praveen",
        address: "",
        contact: "+919632300046",
        cost: "",
        boaring: "",
        note: "Could have the capacity to take in sheeps, cows, etc.",
      },
      {
        name: "Gaushala",
        address: "",
        contact: "+919845366029",
        cost: "",
        boaring: "",
        note: "(for cases around Vasanthnagar, Fraser Town, R T Nagar, Ulsoor)",
      },
      {
        name: "Cow rescuers",
        address: "",
        contact: "+919844203467, +919880212545, +919632038167, +919742906874",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Donkeys/ Camels rescuers",
        address: "",
        contact: "+918088888800, +9108025532204",
        cost: "",
        boaring: "",
        note: "",
      },
    ],
    link: "",
  },
  {
    topic: "Small Animals",
    content: [
      "Here is a list of helpful contacts for assisting smaller animals in need.",
    ],
    contact_list: [
      {
        name: "PFA",
        address: "Sunkalpalya, Bengaluru, Karnataka 560060",
        contact: "General Manager +919741783232 , Dr. Darsh +918884846668",
        cost: "",
        boaring: "",
        note: "Specializes in rescuing small wild animals. They have an ambulance too.",
      },
      {
        name: "ARRC",
        address: "Horamavu",
        contact: "+919620286800",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Kabootar Dana Seva",
        address: "Rajajunagar",
        contact: "+919845221309",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "WRRC",
        address: "Bannerghatta",
        contact: "+9108022947307",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Indian Wildlife",
        address: "BEML Layout",
        contact: "+919900603939",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Rohit",
        address: "",
        contact: "+919964917651, +917353148787",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Snake catchers",
        address: "",
        contact:
          "+919342596704, +919686447818, +919535343976, +919845080903, +918310755854, +919845080903, +9122221188, +919845266488, +919980855720, +919880108801, +919902794711, +919844530033, +919342596704",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Bird Rescuers",
        address: "",
        contact: "+919620286800, +919845221309",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Nakul (Bird/snakes)",
        address: "",
        contact: "+91990463512",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Pigeons",
        address: "",
        contact:
          "+919844443100, +919845221309, +9108023152306, +9123102306, +919341237561",
        cost: "",
        boaring: "",
        note: "",
      },
    ],
    link: "",
  },
  {
    topic: "Transporting Stray Cats and Dogs",
    content: [
      "Here is a list of helpful contacts for transporting STRAY ANIMALS ONLY in need of assistance.",
      "How to transport a cat/dog",
      "One can take an auto and drive, or one can hire a pet transportation service that can drive the animal instead of you.",
      "Please note that all such transportation services carry nets/carriers that have a strong animal smell, and many animals can get freaked out by this smell. So if you are capable of securing the animal on a leash / in a box / in a room before the transportation person takes out their carriers/nets — do that, to minimize the chances of an animal smelling other animals and running away.",
      "Please discuss the cost for each case separately.",
      "Below are contacts of people who provide such transportation services:",
    ],
    contact_list: [
      {
        name: "Deepak",
        address: "",
        contact: "+918088252132, +918310493158",
        cost: "",
        boaring: "",
        note: "Has an auto as well as nets for dogs and carriers for cats.",
      },
      {
        name: "Matthew",
        address: "Electronic City",
        contact: "+918867290030",
        cost: "",
        boaring: "",
        note: "Is a volunteer that lives in Electronic City and can occasionally help",
      },
      {
        name: "Sham",
        address: "",
        contact: "+919380572325",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Jaythra",
        address: "",
        contact: "+919844023522",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Pradeep",
        address: "",
        contact: "+919916944483",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Arun",
        address: "",
        contact: " +918884619616, +918884619616, +918722947494",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Kiran",
        address: "",
        contact: "+919535343976",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Devaraj",
        address: "",
        contact: "+917411002781, +917795330396",
        cost: "",
        boaring: "",
        note: "Is free post 6 pm",
      },
      {
        name: "Alex",
        address: "",
        contact: "+918867290030",
        cost: "",
        boaring: "",
        note: "Is a volunteer who could sometimes helo transport animals free of cost but prefers someone to drive with him to take care of the animal",
      },
      {
        name: "Kumar",
        address: "",
        contact: "+917411475819",
        cost: "",
        boaring: "",
        note: "",
      },
      {
        name: "Ravi Pet Ambulance",
        address: "",
        contact: "+919964814408",
        cost: "",
        boaring: "",
        note: "",
      },
    ],
    link: "",
  },
  {
    topic: "Where to Treat Cats and Dogs",
    content: [
      "Here is a list of useful contacts and locations for treating stray dogs and cats.",
    ],
    contact_list: [
      {
        name: "CUPA TRAUMA CENTER (HEBBAL)",
        address:
          "KVAFSU, Veterinary College Campus, Bellary Rd, opp. CBI, Sanjayanagara, Bengaluru, Karnataka 560024",
        contact: "+918022947300",
        cost: "free",
        boaring: "",
        note: "CUPA Trauma Center is ideal for severe trauma cases that require surgeries and boarding for a long time such as broken bones, open wounds, dog bites, car accidents, etc. Sometimes they don't pick up phone calls, but they are ALWAYS open from 9 am to 5 pm, and never say 'no' to treatment and boarding for severe trauma cases. So please do not hesitate to drive the animal there directly even if no one picks up the phone. I have personally had many great experiences with CUPA Trauma Center, and would strongly recommend everyone to use their services. Usually, every animal leaving the CUPA Trauma Center facility after treatment is also neutered and vaccinated for free. Just make sure you inform the center that you would like to get the cat neutered and vaccinated if it is not already done. In the unlikely case you are told that there is simply not enough boarding space for a cat (as cats have to be kept separately from dogs) — offer a solution of providing a crate in which the cat can be kept at CUPA Trauma Center’s facility. It’s easy to arrange for it, there are many WhatsApp groups with pet parents and volunteers who would be happy to lend you a crate for this purpose.",
      },
      {
        name: "PFA (SOUTH-WEST)",
        address: "Sunkalpalya, Bengaluru, Karnataka 560060",
        contact: "General Manager 9741783232, Dr. Darsh +918884846668",
        cost: "Subsidized (2000 for neutering, for example), and boarding is usually free",
        boaring: "",
        note: "I can vouch for the quality of care provided at PFA. Both Dr. Darsh and the General Manager are usually available on WhatsApp. Do call before bringing the animal in. One can also inquire about the cost of treatment over the phone for each particular case.",
      },
      {
        name: "PAPA'S LIFELINE (Jayanagar)",
        address:
          "No 1610/52, Indu Leela Building, 18th Main, 40th Cross, Jayanagar 4th T Block, Bangalore - 560041 (Opposite Gnr Kalyana Mantapa)",
        contact: "+918042150630",
        cost: "Quite costly as this is a private establishment",
        boaring: "",
        note: "This place is great because it has a boarding facility that is almost always available, and the clinic is open 24/7. Personally, I use this place for instances where an animal can not be shifted to more affordable clinics such as CUPA Trauma Center or PFA right away and needs a place to stay for a night or for a few days. Check fees for each procedure advised and make a call on whether or not to get it done. For example, if an animal is kept at Papa’s Lifeline just for a night and is being shifted to CUPA Trauma Center in the morning, one can decide against doing a blood test at Papa’s since at CUPA it will be done free of cost, etc.",
      },
      {
        name: "FRIENDLY TAILS PET CLINIC (Kanakapura)",
        address: "Subramanyapura, Bengaluru, Karnataka 560061",
        contact: "+9109611460533",
        cost: "Overall very affordable and negotiable, but it’s still a private establishment",
        boaring: "",
        note: "Dr. Tahir is a professional and an animal lover. He provides services very transparently and can help with evaluating the situation and creating a treatment plan taking into account one’s financial and personal circumstances. Personally, I use this place for instances when I foster animals at my home and minor treatments/surgeries are required. Dr. Tahir comes in the evenings.",
      },
      {
        name: "BOZO WAGS (Yellanahalli)",
        address:
          "No. 1, Sri Ganapathi Complex,Yellanahalli, Akshayanagar,Bengaluru 560068.",
        contact: "+91 97405 08008",
        cost: "Quite costly as this is a private establishment",
        boaring: "",
        note: "This place is great because it offers boarding and has an ambulance service. Personally, I use this place for instances where an animal can not be shifted to more affordable clinics such as CUPA Trauma Center or PFA right away and needs a place to stay for a night or for a few days.",
      },
      {
        name: "Jeeva Pet Hospital - JP Nagar (South Bangalore)",
        address: "JP Nagar ",
        contact: "+91 080 4268 7782",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Papa's Life Line Veterinary Hospital - Jayanagar (South Bangalore)",
        address: "Jayanagar",
        contact: "+91 080 4215 0630",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Renee Vet Hospital Jp Nagar ( Veterinary Care In Bangalore)",
        address: "JP Nagar",
        contact: "+91 074067 34689",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Lucky Paws veterinary hospital - Electronic city (South Bangalore)",
        address: "Electronic City",
        contact: "+91 077955 21938",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Advitha pet hospital - Electronic city (South Bangalore)",
        address: "Electronic city",
        contact: "+91 8123587661",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Cessna Lifeline Veterinary Hospital, Domlur (East Bangalore)",
        address: "Domlur",
        contact: "+91 8123587661",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Bangalore Pet hospital - Whitefield (East Bangalore)",
        address: "Whitefield",
        contact: "+91 9902006168 , +917259782425",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Dr. Santa animal healthcare - Whitefield (East Bangalore)",
        address: "Whitefield",
        contact: "+91091647 94750",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Sudheeksha pet hospital - Yelahanka new town (North Bangalore)",
        address: "Yelahanka new town",
        contact: "+91080 4890 8032",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Neha Speciality Veterinary Hospital - Yelahanka (North Bangalore)",
        address: "Yelahanka",
        contact: "+91098441 03321",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "RMV MULTI-SPECIALITY VETERINARY CLINIC - New Bel road (North Bangalore)",
        address: "New Bel road",
        contact: "+91097398 00026",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
      {
        name: "Sanchu animal hospital - Kormangala (Central Bangalore)",
        address: "Kormangala",
        contact: "+91078258 81528",
        cost: "",
        boaring: "",
        note: "24/7 Clinic",
      },
    ],
    link: "",
  },
];
